import highlight from './highlight';
import lowlight from 'lowlight/lib/core';
var SyntaxHighlighter = highlight(lowlight, {});
SyntaxHighlighter.registerLanguage = lowlight.registerLanguage;
export default SyntaxHighlighter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-syntax-highlighter/dist/esm/light.js
// module id = 3646
// module chunks = 0